import React from "react";

import { Rectangle } from "recharts";

import type { JSX } from "react";
import type { BarShapeProps } from "recharts";

export type BarRadius = [number, number, number, number];

// Rounds only the last non-empty segment of each stacked bar.
export function endRoundedBarShape<TKey extends string>(
  rowList: readonly { endSeriesKey?: TKey }[],
  seriesKey: TKey,
  radius: BarRadius,
): (props: BarShapeProps) => JSX.Element {
  return function EndRoundedBar({
    fill,
    height,
    index,
    stroke,
    width,
    x,
    y,
  }: BarShapeProps): JSX.Element {
    return (
      <Rectangle
        fill={fill}
        height={height}
        radius={rowList[index]?.endSeriesKey === seriesKey ? radius : 0}
        stroke={stroke}
        width={width}
        x={x}
        y={y}
      />
    );
  };
}
